// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from '@/components/app'
import RepositoryService from '@/services/repositoryService'
import router from '@/router'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import 'vue-material/dist/theme/default.css'
import VeeValidate from 'vee-validate'
import { i18n } from '@/plugins/i18n.js'

Vue.config.productionTip = false

Vue.use(VueMaterial)
Vue.use(VeeValidate, {
  events: 'blur'
})
RepositoryService.init()

Vue.directive('permission', function (el, binding) {
  if (!RepositoryService.session.hasPermission(binding.arg)) {
    if (el.nodeName !== 'INPUT' || el.nodeName !== 'TEXTAREA' || el.nodeName !== 'BUTTON') {
      setChildNodes(el, 'hide')
    } else {
      el.style.display = 'none'
    }
  }
})

Vue.directive('canEdit', function (el) {
  if (!RepositoryService.session.hasPermission('canEditContent')) {
    if (el.nodeName !== 'INPUT' || el.nodeName !== 'TEXTAREA' || el.nodeName !== 'BUTTON') {
      setChildNodes(el, 'disabled')
    } else {
      el.disabled = true
    }
  }
})

function setChildNodes (el, type) {
  for (var index = 0; index < el.children.length; index++) {
    var childElement = el.children[index]
    if (childElement && (childElement.nodeName === 'INPUT' || el.nodeName !== 'TEXTAREA' || el.nodeName !== 'BUTTON')) {
      if (type === 'disabled') {
        childElement.disabled = true
      } else {
        childElement.style.display = 'none'
      }
    }
    if (childElement.children) {
      setChildNodes(childElement)
    }
  }
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  template: '<App/>',
  components: {
    App
  }
})
/* eslint-enable no-new */
